module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson6/pages/lesson_6_4.pdf";